export default "__VITE_ASSET__BbXnDXBd__"